// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3fn7W","content":"styles_content__3S7Wp","selectAll":"styles_selectAll__1D6ir"};